export default __webpack_public_path__ + "static/media/trans-3.90ab35b1.jpg";